export enum TemplateFieldDataType {
    text,
    number,
    decimal,
    yesNo,
    date
}
